import { TwoFactorBackupCodesDialogComponent } from './components/two-factor-backup-codes-dialog/two-factor-backup-codes-dialog.component';
import { TwoFactorBackupCodesComponent } from './components/two-factor-backup-codes/two-factor-backup-codes.component';
import { TwoFactorMethodSelectorComponent } from './components/two-factor-method-selector/two-factor-method-selector.component';
import { TwoFactorMethodSetupAuthAppComponent } from './components/two-factor-method-setup-auth-app/two-factor-method-setup-auth-app.component';
import { TwoFactorMethodSetupCommonComponent } from './components/two-factor-method-setup-common/two-factor-method-setup-common.component';
import { TwoFactorMethodSetupEmailComponent } from './components/two-factor-method-setup-email/two-factor-method-setup-email.component';
import { TwoFactorMethodSetupPhoneComponent } from './components/two-factor-method-setup-phone/two-factor-method-setup-phone.component';
import { TwoFactorMethodSetupStepComponent } from './components/two-factor-method-setup-step/two-factor-method-setup-step.component';
import { TwoFactorMethodSetupVerifyComponent } from './components/two-factor-method-setup-verify/two-factor-method-setup-verify.component';
import { TwoFactorMethodTypeSelectorDropdownComponent } from './components/two-factor-method-type-selector-dropdown/two-factor-method-type-selector-dropdown.component';
import { TwoFactorMethodComponent } from './components/two-factor-method/two-factor-method.component';
import { TwoFactorScreenComponent } from './components/two-factor-screen/two-factor-screen.component';
import { TwoFactorToastExpiredTokenComponent } from './components/two-factor-toast-expired-token/two-factor-toast-expired-token.component';
import { TwoFactorUnlockComponent } from './components/two-factor-unlock/two-factor-unlock.component';
import { TwoFactorVerificationCodeComponent } from './components/two-factor-verification-code/two-factor-verification-code.component';
import { SharedModule } from '../../shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PplComponentsInputPhoneNumberModule } from '@ppl/components/input-phone-number';
import { PplInputModule } from '@ppl/ui/input';
import { PplMenuModule } from '@ppl/ui/menu';
import { PplPopoverModule } from '@ppl/ui/popover';
import { PplPopoverDropdownModule } from '@ppl/ui/popover-dropdown';
import { PplRadioModule } from '@ppl/ui/radio';
import { PplSlideToggleModule } from '@ppl/ui/slide-toggle';
import { PplToastModule } from '@ppl/ui/toast';


const EXPORTED_MODULES = [
  TwoFactorMethodSetupStepComponent,
  TwoFactorMethodSetupEmailComponent,
  TwoFactorMethodSetupVerifyComponent,
  TwoFactorMethodSetupAuthAppComponent,
  TwoFactorMethodSetupCommonComponent,
  TwoFactorMethodSetupPhoneComponent,
  TwoFactorUnlockComponent,
  TwoFactorToastExpiredTokenComponent,
  TwoFactorScreenComponent,
  TwoFactorMethodSelectorComponent,
  TwoFactorMethodTypeSelectorDropdownComponent,
  TwoFactorVerificationCodeComponent,
  TwoFactorBackupCodesDialogComponent,
  TwoFactorBackupCodesComponent,
  TwoFactorMethodComponent
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PplToastModule,
    PplMenuModule,
    PplPopoverModule,
    PplPopoverDropdownModule,
    PplInputModule,
    PplRadioModule,
    PplSlideToggleModule,
    PplComponentsInputPhoneNumberModule,
    SharedModule
  ],
  declarations: [
    ...EXPORTED_MODULES
  ],
  exports: [
    ...EXPORTED_MODULES
  ]
})
export class TwoFactorModule { }
